import { render, staticRenderFns } from "./CarouselListWrapperParts.vue?vue&type=template&id=2295fcdd&scoped=true"
import script from "./CarouselListWrapperParts.vue?vue&type=script&lang=ts"
export * from "./CarouselListWrapperParts.vue?vue&type=script&lang=ts"
import style0 from "./CarouselListWrapperParts.vue?vue&type=style&index=0&id=2295fcdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295fcdd",
  null
  
)

export default component.exports